
import { init } from '_trackers';

import * as sentry from '../tools/sentry';
import { VERSIONS } from './versions';

export const initTracker = () => {
    init({ appName: 'Odyssey', version: `${VERSIONS.version} - ${VERSIONS.admin}`, errorHandler: sentry });
};
